import api from '../../api/docomo'
import middle from '../../api/middle_layer'
import moment from 'moment'
import Constants from '../../constants'
import _ from 'lodash'

const getDefaultState = () => {
  return {
    mode: false,
    /*
     * DETAIL: ポート詳細
     * TENTATIVE: 仮予約
     * APPROVE: 確定
     * RESERVED: 予約詳細
     */
    status: 'DETAIL',
    /*
     * 出発・到着地の指定方法
     * BUSSTOP: ポート
     * POSITION: 緯度経度
     */
    type: 'BUSSTOP',
    departure: {},
    arrival: {},
    datetime: moment().add(5, 'minute').startOf('minute'),
    adult: 1,
    child: 0,
    reserved: {},
    serviceAreaId: null,
    position: {
      name: '',
      location: {
        lat: 0,
        lng: 0
      }
    },
    showErrorModal: false
  }
}

const state = getDefaultState()

const getters = {
  getStatus: (state) => state.status,
  getDeparture: (state) => state.departure,
  getArrival: (state) => state.arrival,
  getDateTime: (state) => state.datetime,
  getDate: (state) => state.datetime.format('YYYY-MM-DD'),
  getTime: (state) => state.datetime.format('HH:mm'),
  getAdult: (state) => state.adult,
  getChild: (state) => state.child,
  getReserved: (state) => state.reserved,
  getMode: (state) => state.mode,
  getType: (state) => state.type,
  getServiceAreaId: (state) => state.serviceAreaId,
  getIsReserving: (state)  => state.mode && state.status !== 'RESERVED',
  getPosition: (state) => state.position,
  getShowErrorModal: (state) => state.showErrorModal,
  isCancelable: (state, getters, rootGetters) => {
    // 乗車前
    const r = state.reserved
    const { status } = r
    const s = _.includes(['ASSIGNING', 'ASSIGNED', 'PICKING_UP'], status)

    // アクティベートしていない
    const t = rootGetters.user.ticket
    const a = t && !t.activate

    return s && a
  }
}

const actions = {
  start ({ commit }, busstop) {
    commit('setStatus', 'TENTATIVE')
    commit('setDeparture', busstop)
  },
  updateDeparture ({ commit }, busstop) {
    commit('setStatus', 'TENTATIVE')
    commit('setDeparture', busstop)
  },
  updateArrival ({ commit }, busstop) {
    commit('setStatus', 'TENTATIVE')
    commit('setArrival', busstop)
  },
  updateStatusTentative ({ commit }) {
    commit('setStatus', 'TENTATIVE')
  },
  tentative ({ dispatch, commit, state, getters, rootGetters }) {
    const { datetime, departure, arrival, adult, child, type } = state
    const serviceAreaId = getters['getServiceAreaId']
    const token = rootGetters['user/getBearerToken'](serviceAreaId)
    const maebashi = rootGetters['user/isMaebashi']
    let points
    let fareId = serviceAreaId

    if (maebashi == true) {
      fareId = 10000 + serviceAreaId
    }

    if (type == 'BUSSTOP') {
      points = {
        pickUpBusstopId: departure.id,
        dropOffBusstopId: arrival.id
      }
    } else {
      points = {
        pickUpPosition: departure.location,
        dropOffPosition: arrival.location
      }
    }

    const params = {
      ...points,
      serviceAreaId: serviceAreaId,
      seatCountDetail: {
        adult: adult,
        child: child
      },
      pickUpTime: datetime.format(),
      lang: 'ja',
      fareId: fareId
    }

    dispatch('loading/beginLoading', {}, { root: true })
    return new Promise((resolve,reject) => {
      api.tentative(serviceAreaId, token, params)
        .then((reservation) => {
          commit('setReserved', reservation)
          commit('setStatus', 'APPROVE')
          resolve(reservation)
        })
        .catch(error => {
          console.log(`tentative: ${error.response}`)
          reject(error)
        })
        .finally(()=> {
          dispatch('loading/endLoading', {}, { root: true })
        })
    })
  },
  approve ({ dispatch, commit, state, getters, rootGetters }) {
    const { reserved } = state
    const serviceAreaId = getters['getServiceAreaId']
    const token = rootGetters['user/getBearerToken'](serviceAreaId)
    const jreToken = rootGetters['user/getToken']

    dispatch('loading/beginLoading', {}, { root: true })
    return new Promise(() => {
      api.approve(serviceAreaId, token, reserved.id)
        .then(() => {
          middle.create(serviceAreaId, jreToken, reserved)
          commit('setStatus', 'RESERVED')
        })
        .catch((error) => {
          console.log(`approve: ${error.response}`)
        })
        .finally(() => {
          dispatch('loading/endLoading', {}, { root: true })
        })
    })
  },
  decline ({ dispatch, commit, state, getters, rootGetters }) {
    const { reserved } = state
    const serviceAreaId = getters['getServiceAreaId']
    const token = rootGetters['user/getBearerToken'](serviceAreaId)

    dispatch('loading/beginLoading', {}, { root: true })
    return new Promise((resolve) => {
      api.decline(serviceAreaId, token, reserved.id)
        .then(() => {
          commit('resetState')
          dispatch('drawer/close', {}, { root: true })
        })
        .catch(error => {
          console.log(`decline: ${error.response}`)
        })
        .finally(() => {
          dispatch('loading/endLoading', {}, { root: true })
          resolve()
        })
    })
  },
  cancel ({ dispatch, commit, state, rootGetters }) {
    const { reserved, serviceAreaId } = state
    const token = rootGetters['user/getBearerToken'](serviceAreaId)
    const jreToken = rootGetters['user/getToken']

    dispatch('loading/beginLoading', {}, { root: true })
    return new Promise((resolve) => {
      api.cancel(serviceAreaId, token, reserved.id)
        .then(() => {
          middle.cancel(serviceAreaId, jreToken, reserved)
            .then(() => {
              commit('resetState')
              dispatch('drawer/close', {}, { root: true })
              resolve()
            })
        })
        .catch(error => {
          console.log(`cancel: ${error.response}`)
        })
        .finally(() => {
          dispatch('loading/endLoading', {}, { root: true })
        })
    })
  },
  fetchAndSetup ({ dispatch, commit, state, rootGetters }, id) {
    const { serviceAreaId } = state
    const s = Constants.DOCOMO_SERVICE_AREAS.find((a) => a.id == serviceAreaId)

    return new Promise(() => {
      dispatch('fetch', id)
        .then((reservation) => {
          if (s.type == 'BUSSTOP') {
            const busstop = rootGetters['busstops/get'](reservation.pickUpBusstopId)
            dispatch('drawer/updateTarget', busstop, { root: true })
          } else if (s.type == 'POSITION') {
            commit('setDeparturePosition', { location: reservation.pickUpPosition })
            commit('setArrivalPosition', { location: reservation.dropOffPosition })
          }
          dispatch('drawer/forceOpen', {}, { root: true })
          dispatch('map/updateCenter', reservation.pickUpPosition, { root: true })
        })
    })
  },
  fetch ({ commit, state, rootGetters }, id) {
    const { serviceAreaId } = state
    const token = rootGetters['user/getBearerToken'](serviceAreaId)

    return new Promise((resolve) => {
      api.getReservation(serviceAreaId, token, id)
        .then((reservation) => {
          commit('setReserved', reservation)
          commit('setStatus', 'RESERVED')
          resolve(reservation)
        })
    })
  },
  updateDetailMode ({ commit }) {
    commit('setStatus', 'DETAIL')
  },
  activateMode ({ commit, dispatch }, serviceAreaId) {
    const s = Constants.DOCOMO_SERVICE_AREAS.find((a) => a.id == serviceAreaId)

    commit('setMode', true)
    commit('setServiceAreaId', serviceAreaId)
    commit('setType', s.type)
    if (s.type == 'POSITION') {
      dispatch('drawer/forceOpen', {}, { root: true })
      commit('setStatus', 'TENTATIVE')
    }
  },
  deactivateMode ({ commit }) {
    commit('setMode', false)
  },
  updateAdult ({ commit }, num) {
    commit('setAdult', num)
  },
  updateChild ({ commit }, num) {
    commit('setChild', num)
  },
  updateDateTime ({ commit }, datetime) {
    commit('setDateTime', datetime)
  },
  updatePosition ({ commit, rootGetters }, location) {
    const api = rootGetters['googleMap/getApi']
    const geocoder = new api.maps.Geocoder

    geocoder.geocode({'location': location}, function(results, status) {
      if (status === api.maps.GeocoderStatus.OK) {
        let name = `${location.lat}, ${location.lng}`
        if (results[0]) {
          const a = results[0].formatted_address.split(' ')
          name = `${a[1]}` // ${a[1]} ${name}`
        }
        const position = {
          name: name,
          location: location
        }
        commit('setPosition', position)
      } else {
        console.log('Geocoder failed due to: ' + status)
      }
    })
  },
  updateDeparturePosition ({ commit }) {
    commit('setDeparturePosition')
  },
  updateArrivalPosition ({ commit }) {
    commit('setArrivalPosition')
  },
  fetchPeriodically ({ dispatch, state }) {
    setInterval(() => {
      const { reserved } = state
      const now = moment()
      let f

      if (reserved) {
        // 乗車予定の10分前
        f = reserved.latestEstimatePickUpTime.diff(now, 'minutes') < 10 && (reserved.status == 'PICKING_UP' || reserved.status == 'BOARDING')
      }
      if (f) {
        dispatch('fetch', reserved.id)
      }
      dispatch('geolocation/fetchLocation', {}, { root: true })
    }, 10000)
  },
  handleError ({ commit }) {
    commit('setShowErrorModal', true)
  },
  handleErrorOff ({ commit }) {
    commit('setShowErrorModal', false)
  },
  selectDeparture ({ commit }, busstop) {
    commit('setDeparture', busstop)
  },
  selectArrival ({ commit }, busstop) {
    commit('setArrival', busstop)
  }
}

const mutations = {
  setStatus (state, status) {
    state.status = status
  },
  setDeparture (state, busstop) {
    state.departure = busstop
  },
  setArrival (state, busstop) {
    state.arrival = busstop
  },
  setReserved (state, reservation) {
    state.reserved = reservation
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  },
  setMode (state, mode) {
    state.mode = mode
  },
  setServiceAreaId (state, serviceAreaId) {
    state.serviceAreaId = serviceAreaId
  },
  setAdult (state, num) {
    state.adult = num
  },
  setChild (state, num) {
    state.child = num
  },
  setDateTime (state, datetime) {
    state.datetime = datetime
  },
  setPosition (state, position) {
    state.position = position
  },
  setDeparturePosition (state, position = state.position) {
    state.departure = Object.assign({}, position)
  },
  setArrivalPosition (state, position = state.position) {
    state.arrival = Object.assign({}, position)
  },
  setType (state, type) {
    state.type = type
  },
  setShowErrorModal (state, flag) {
    state.showErrorModal = flag
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
